/**
 * Note Service
 * Handles note-related API calls
 */
import BaseApiService from '../base/BaseApiService';
import type { NotesResponse, NoteEntityType, CreateNoteRequest, CreateNoteResponse } from '@app-types';

class NoteService extends BaseApiService {
  /**
   * Get notes for an entity
   */
  async getNotes(entityType: NoteEntityType, entityId: number): Promise<NotesResponse> {
    return this.get<NotesResponse>(`/notes/${entityType}/${entityId}`);
  }

  /**
   * Create a note for an entity
   */
  async createNote(entityType: NoteEntityType, entityId: number, data: CreateNoteRequest): Promise<CreateNoteResponse> {
    return this.post<CreateNoteResponse>(`/notes/${entityType}/${entityId}`, data);
  }
}

export const noteService = new NoteService();
export default noteService;
